import { Heading } from "@radix-ui/themes";

interface HeadingProps {
  children?: React.ReactNode;
  id?: string;
  isCentered?: boolean;
  isFirst?: boolean;
  isTableOfContents?: boolean;
  isExtraMargin?: boolean;
}

export const H1: React.FC<HeadingProps> = ({
  children,
  isCentered,
  isFirst,
  isExtraMargin,
}) => {
  return (
    <Heading
      as="h1"
      size="6"
      color="indigo"
      mt={isFirst ? "0" : "4"}
      mb={isExtraMargin ? "6" : ""}
      align={isCentered ? "center" : "left"}
    >
      {children}
    </Heading>
  );
};

export const H2: React.FC<HeadingProps> = ({
  children,
  id,
  isCentered,
  isFirst,
  isTableOfContents,
}) => {
  return (
    <Heading
      align={isCentered ? "center" : "left"}
      aria-hidden={isTableOfContents}
      as="h2"
      color="indigo"
      id={id}
      mt={isFirst ? "0" : "8"}
      size="5"
      style={{
        scrollMarginTop: "60px",
        ...(isTableOfContents ? { color: "var(--color-background)" } : {}),
      }}
    >
      {children}
    </Heading>
  );
};

export const H3: React.FC<HeadingProps> = ({
  children,
  id,
  isCentered,
  isFirst,
}) => {
  return (
    <Heading
      align={isCentered ? "center" : "left"}
      as="h3"
      color="indigo"
      id={id}
      mt={isFirst ? "0" : "5"}
      size="3"
      style={{
        scrollMarginTop: "40px",
      }}
    >
      {children}
    </Heading>
  );
};
